import urls from "web/constants/urls";

export const hiddenHeaderDesktopPathNames = [
  urls.checkoutDefaultPayments,
  urls.checkoutDefaultSummary,
  urls.checkoutInternationalTourismPayments,
  urls.checkoutInternationalTourismSummary,
  urls.checkoutDomesticTourismInformation,
  urls.checkoutDomesticTourismPayments,
  urls.checkoutDomesticTourismSummary,
  urls.checkoutSubscriptionConfiguration,
  urls.checkoutSubscriptionInformation,
  urls.checkoutSubscriptionAgreements,
  urls.checkoutSubscriptionSummary,
  urls.checkoutSubscriptionBlocked,
  urls.checkoutBuyNowPayments,
  urls.checkoutBuyNowSummary,
  urls.checkoutSplash,
  urls.checkoutExternalPrepaid,
];

export const moduleHeaderPaths = [
  { path: urls.proposals, label: "Wnioski i Dofinansowania" },
  { path: urls.totalRewardStatement, label: "TRS" },
  { path: urls.companyEvents, label: "Imprezy Firmowe" },
  { path: urls.subscriptions, label: "Abonamenty" },
];
